import useSWR from "swr";
import fetch from "isomorphic-unfetch";
import { caseConvertGetRandomPatternListResponse } from "../../utils/responseCaseConverter";

const fetcher = (path: string) => {
  return fetch(
    `${process.env.NEXT_PUBLIC_AVATARTRAINING_AI_API_DOMAIN}${path}`
  ).then((res) => res.json());
};

interface UseRandomPatternProps {
  language: string;
  avatarType: string;
  mode?: string;
}

const useRandomPattern = ({
  language,
  avatarType,
  mode = "ai",
}: UseRandomPatternProps) => {
  const { data, error } = useSWR(
    `/avatartraining/ai-experiment-random-pattern?language=${language}&avatar_type=${avatarType}&mode=${mode}`,
    fetcher,
    { revalidateOnFocus: false }
  );
  return {
    data: data ? caseConvertGetRandomPatternListResponse(data) : data,
    isLoading: !error && !data,
    isError: error,
  };
};

export { useRandomPattern };
